import React from "react";
import { motion } from "framer-motion";
import {
  Settings2,
  Headphones,
  Ticket,
  BarChart3,
  Users,
  GitBranch,
} from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const ICONS = [Settings2, Headphones, Ticket, BarChart3, Users, GitBranch];

const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="py-24 lg:py-32 bg-[var(--ivory)]" data-testid="services-section">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <span className="overline" data-testid="services-overline">{t.services.overline}</span>
          <h2 className="font-serif text-[34px] sm:text-[42px] lg:text-[52px] leading-[1.08] tracking-tight text-[var(--navy)] mt-6" data-testid="services-title">
            {t.services.title}
          </h2>
          <p className="mt-6 text-[16px] lg:text-[17px] leading-[1.8] text-[var(--charcoal)]" data-testid="services-subtitle">
            {t.services.subtitle}
          </p>
          <div className="mt-8 w-14 h-px bg-[var(--champagne)]" />
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {t.services.items.map((item, idx) => {
            const Icon = ICONS[idx];
            return (
              <motion.article
                key={idx}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: idx * 0.08 }}
                className="service-card"
                data-testid={`service-card-${idx}`}
              >
                <span className="icon-wrap">
                  <Icon className="w-5 h-5" strokeWidth={1.3} />
                </span>
                <p className="overline mb-3">{String(idx + 1).padStart(2, "0")}</p>
                <h3 className="font-serif text-[24px] lg:text-[26px] leading-[1.2] text-[var(--navy)]" data-testid={`service-title-${idx}`}>
                  {item.title}
                </h3>
                <p className="mt-4 text-[15px] leading-[1.75] text-[var(--charcoal)]">
                  {item.desc}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
